import { FiltrableOption, Option, OrderedOption } from 'types/Generics';
import { TimeLimit } from 'types/OnlineBooking';
import { PetSize, PetType, PetTypeId } from 'types/Pet';

export const emptyMasterData: MasterData = {
    petTypes: [],
    petBreeds: [],
    petAges: [],
    petGenders: [],
    petSizes: [],
    petHairColors: [],

    relationships: [],

    olbFromLimits: [],
    olbToLimits: [],

    paymentTypes: []
};

export interface MasterData {
    petTypes: Array<PetType>;
    petBreeds: Array<FiltrableOption<number, PetTypeId>>;
    petAges: Array<Option<string>>;
    petGenders: Array<Option<string>>;
    petSizes: Array<OrderedOption<PetSize>>;
    petHairColors: Array<FiltrableOption<string, PetTypeId>>;

    relationships: Array<Relationship>;

    olbFromLimits: Array<TimeLimit>;
    olbToLimits: Array<TimeLimit>;

    // Required in @spike/invoices-action
    paymentTypes: Array<unknown>;
}

export type Relationship = Option<number>;
